export const ROLES_TREE = [
    {
        "data": {
            "txtTypeRole": "ROL_ADMINISTRADOR",
            "cdTypeRole": "Administrador"
        },
        "children": [
            {
                "data": {
                    "txtTypeRole": "ROL_ADMINISTRACION_GLOBAL",
                    "cdTypeRole": "Este rol es el encargado de administrar y gestionar la parte global y sus subsecciones cierre de periodos, listas descriptivas, etiquetas, variables de riesgo, imputaciones de tiempo, naturaleza de gasto, alarmas y parámetros"
                }
            },
            {
                "data": {
                    "txtTypeRole": "ROL_ADMINISTRACION_DIVISAS",
                    "cdTypeRole": "Este rol es el encargado de administrar y gestionar la parte de divisas y sus subsecciones tipos, tipos de cambio y previsiones de cambio"
                }
            },
            {
                "data": {
                    "txtTypeRole": "ROL_ADMINISTRACION_ESTRUCTURAS",
                    "cdTypeRole": "Este rol es el encargado de administrar y gestionar la parte de estructuras y sus subsecciones entidades, paises, regiones, areas territoriales y estructuras organizativas"
                }
            },
            {
                "data": {
                    "txtTypeRole": "ROL_ADMINISTRACION_RHUMANOS",
                    "cdTypeRole": "Administrador de la parte de recursos humanos"
                }
            },
            {
                "data": {
                    "txtTypeRole": "ROL_ADMINISTRACION_USUARIOS",
                    "cdTypeRole": "Administrador de la parte de usuarios"
                }
            },
            {
                "data": {
                    "txtTypeRole": "ROL_ADMINISTRACION_AEXTERNAS",
                    "cdTypeRole": "Administrador de la parte de auditorias externas"
                }
            },
            {
                "data": {
                    "txtTypeRole": "ROL_ADMINISTRACION_CUESTIONARIOS",
                    "cdTypeRole": "Administrador de la parte de cuestionarios"
                }
            },
            {
                "data": {
                    "txtTypeRole": "ROL_ADMINISTRACION_NOTICIAS",
                    "cdTypeRole": "Administrador de la parte de Noticias"
                }
            },
            {
                "data": {
                    "txtTypeRole": "ROL_ADMINISTRACION_PROCESOS",
                    "cdTypeRole": "Administrador de la parte de procesos"
                }
            },
            {
                "data": {
                    "txtTypeRole": "ROL_ADMINISTRACION_PROGRAMA_TRABAJOS",
                    "cdTypeRole": "Administrador de la parte de programas"
                }
            }
        ]
    },
    {
        "data": {
            "txtTypeRole": "ROL_DIRECTOR",
            "cdTypeRole": "Director"
        },
        "children": []
    },
    {
        "data": {
            "txtTypeRole": "ROL_JEFE_DE_AREA",
            "cdTypeRole": "Jefe de área"
        },
        "children": []
    },
    {
        "data": {
            "txtTypeRole": "ROL_AUDITOR",
            "cdTypeRole": "Auditor"
        },
        "children": []
    },
    {
        "data": {
            "txtTypeRole": "ROL_AUDITADO",
            "cdTypeRole": "Auditado"
        },
        "children": []
    },
    {
        "data": {
            "txtTypeRole": "ROL_VALIDADOR",
            "cdTypeRole": "Validador"
        },
        "children": []
    },
    {
        "data": {
            "txtTypeRole": "ROL_ASISTENTE",
            "cdTypeRole": "Asistente"
        },
        "children": []
    }
]